var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 23a1 1 0 01-1 1H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h8c2.757 0 5 2.243 5 5v2a1 1 0 11-2 0V5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h4a1 1 0 011 1zm4-17a1 1 0 00-1-1H5a1 1 0 100 2h8a1 1 0 001-1zm-4 5a1 1 0 00-1-1H5a1 1 0 100 2h4a1 1 0 001-1zm-5 4a1 1 0 100 2h2a1 1 0 100-2H5zm19 2c0 3.859-3.141 7-7 7s-7-3.141-7-7 3.141-7 7-7 7 3.141 7 7zm-2 0c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5zm-3.192-1.241l-2.223 2.134a.374.374 0 01-.522.002l-1.131-1.108a.999.999 0 10-1.4 1.428l1.132 1.109c.46.449 1.062.674 1.663.674s1.201-.225 1.653-.671l2.213-2.124a1 1 0 00-1.385-1.443z"
  })));
}
export default SvgOrdersSvg;